<template>
    <ModalTemplate
        :show="show"
        :title="$lang.get('Favorite settings')"
        @close="close"
        width="max-w-2xl w-full"
    >
        <ReactiveHeightTransition>
            <div
                class="flex flex-col gap-y-4 max-h-[50vh] overflow-y-auto p-1"
                v-if="!loading"
            >
                Fill in the content here
            </div>
            <div v-else class="flex flex-col justify-center items-center p-5">
                <PhCircleNotch class="size-8 animate-spin text-primary" />
                <p
                    class="animate-pulse"
                    v-text="$lang.get('Fetching networks')"
                />
            </div>
        </ReactiveHeightTransition>
    </ModalTemplate>
</template>

<script>
import { PhCircleNotch, PhQuestion } from '@phosphor-icons/vue'

import ModalTemplate from '@/Components/Templates/ModalTemplate.vue'
import ReactiveHeightTransition from '@/Components/Transitions/ReactiveHeightTransition.vue'
import Checkbox from '@/Components/FormElements/Checkbox.vue'
import TextTooltip from '@/Components/Elements/TextTooltip.vue'

export default {
    name: 'FavoriteSettingModal',

    components: {
        ModalTemplate,
        ReactiveHeightTransition,
        PhCircleNotch,
        PhQuestion,
        Checkbox,
        TextTooltip,
    },

    expose: ['open'],

    data() {
        return {
            show: false,
            loading: true,
        }
    },

    watch: {
        show(value) {
            if (value) {
                // this.fetchSettings()
            } else {
                // this.relations = []
                // this.favorites = []

                this.loading = true
            }
        },
    },

    methods: {
        close() {
            this.show = false
        },
    },
}
</script>
